import React, { useState } from 'react';

import { Form, Input, Row } from 'antd';

interface IProps {
  placeholder: string;
  onSearchClick: (value: string) => void;
  isLoading: boolean;
}

export const SearchControls: React.FC<IProps> = (props) => {
  const [value, setValue] = useState('');

  return (
    <Row style={{ gap: 16 }} justify="end">
      <Form.Item>
        <Input.Search
          size="middle"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={props.placeholder}
          enterButton
          disabled={props.isLoading}
          onSearch={props.onSearchClick}
        />
      </Form.Item>
    </Row>
  );
};
